module.exports = __webpack_public_path__ + "img/mailbox-promotion.eb7db46b.png";